import { atom } from 'recoil';

export interface AssistantChatFeedbackData {
  scienceApiReq?: string;
  scienceApiRes?: string;
  currentTime?: string;
  preferences?: string;
  appApiRes?: string;
  sessionType?: string;
  sessionId?: string;
  prompt?: string;
}

export const assistantChatFeedbackAtom = atom<AssistantChatFeedbackData | null>({
  key: 'assistantChat.feedbackData',
  default: null,
});

export const assistantChatProcessedIdsAtom = atom<string[]>({
  key: 'assistantChat.processedIds',
  default: [],
});

export const isMealSuggestingAtom = atom<boolean>({
  key: 'assistantChat.isMealSuggesting',
  default: false,
});
